import { detectLanRelay } from '~/modules/remote-mic/network/server/transport/lan-relay-server';
import isPreRendering from '~/modules/utils/is-pre-rendering';
import storage from '~/modules/utils/storage';
import { RemoteMicConnectionTypeSetting } from '~/routes/settings/settings-state';

const SETTING_KEY = 'settings-RemoteMicConnectionType';

/**
 * Asked once, at boot, so the answer is in before anybody opens the phone-connection screen: does
 * the machine serving this game host a relay of its own? When it does - `pnpm start:https` on the
 * LAN, or a preview of a build - the phones meet the game on it, and the room, the pitch and every
 * keypress in it stay in the house.
 *
 * Lives here rather than beside the setting it writes, which would import its way into a cycle:
 * working out whether a phone could reach this origin needs the room-link rules, and those read a
 * setting. Left alone until the answer is in - a transport somebody chose by hand, or a spec
 * seeded, is theirs to keep.
 */
export const preferLanRelayWhenHosted = () => {
  if (isPreRendering || storage.session.getItem(SETTING_KEY) !== null) return;

  void detectLanRelay().then((available) => {
    if (available) RemoteMicConnectionTypeSetting.set('LanRelay');
  });
};
